//import { useCallback, useEffect, useMemo, useState } from "react";
import {
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { Button, Modal } from "react-bootstrap";
import CPunchRes from "../../common/CPunchRes";

const SalePunched = () => {
    const inquiryRef = useRef(null);
    //const [refreshKey, setRefreshKey] = useState(0);
    //const [isSales, setIsSales] = useState(false);
    const [currentUserId, setCurrentUserId] = useState(null);

    const [showRemarksHistory, setShowRemarksHistory] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState([]);


    const openRemarksHistory = (row) => {
        setSelectedRemarks(row.remarks || []);
        setShowRemarksHistory(true);
    };

    const closeRemarksHistory = () => {
        setSelectedRemarks([]);
        setShowRemarksHistory(false);
    };

    useEffect(() => {
        const roleId = Number(localStorage.getItem("roleid"));
        const role = localStorage.getItem("rolename")?.toLowerCase();

        const userPermissionRoleId = Number(
            localStorage.getItem("userPermissionRoleId")
        );

        const salesPunchRoleId = Number(
            localStorage.getItem("salesPunchRoleId")
        );

        if (roleId === 1 || role === "admin") {
            setCurrentUserId(null);
        } else if (roleId === salesPunchRoleId) {
            setCurrentUserId(null);
        } else if (roleId === userPermissionRoleId) {
            setCurrentUserId(Number(localStorage.getItem("userid")));
        }
    }, []);


   const columnDefs = useMemo(
  () => [
    {
      headerName: "Name",
      field: "name",
    },
    {
      headerName: "Mobile",
      field: "mobile",
    },
    {
      headerName: "Consultation",
      field: "consultation",
    },
    {
      headerName: "Address",
      field: "address",
    },
    {
      headerName: "PinCode",
      field: "pinCode",
    },
    {
      headerName: "City",
      field: "city",
    },
    {
      headerName: "State",
      field: "state",
    },
    {
      headerName: "Remarks",
      field: "remarks",
      width: 140,
      sortable: false,
      filter: false,
      cellRenderer: ({ data }) => {
        const count = data?.remarks?.length || 0;

        return (
          <span
            style={{
              color: "#0d6efd",
              cursor: count > 0 ? "pointer" : "default",
              textDecoration: count > 0 ? "underline" : "none",
              fontWeight: 600,
            }}
            onClick={() => count > 0 && openRemarksHistory(data)}
          >
            {count} Remark{count !== 1 ? "s" : ""}
          </span>
        );
      },
    },
    {
      headerName: "Assign Date",
      field: "assignDate",
      valueFormatter: (params) => {
        if (!params.value) return "";

        return new Date(params.value).toLocaleDateString("en-GB");
      },
    },
  ],
  []
);

    return (
        <>

            <CPunchRes
                ref={inquiryRef}
                columnDefs={columnDefs}
                h4="Customer Deny"
                userId={currentUserId}
                punch={true}
                ringing={null}
                deny={null}
            />

            <Modal
                show={showRemarksHistory}
                onHide={closeRemarksHistory}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Remarks History ({selectedRemarks.length})
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedRemarks.length === 0 ? (
                        <div className="text-center">No Remarks Found.</div>
                    ) : (
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Status</th>
                                    <th>Follow Up Date</th>
                                    <th>Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRemarks.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.followUpSts}</td>
                                        <td>
                                            {item.followUpDate
                                                ? new Date(item.followUpDate).toLocaleString("en-IN")
                                                : "-"}
                                        </td>
                                        <td>{item.remark}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={closeRemarksHistory}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SalePunched;